"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Cloud API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SampleDataApi = exports.SampleDataApiFactory = exports.SampleDataApiFp = exports.SampleDataApiAxiosParamCreator = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const base_1 = require("../base");
/**
 * SampleDataApi - axios parameter creator
 * @export
 */
const SampleDataApiAxiosParamCreator = function (axiosClientConfiguration) {
    return {
        /**
         *
         * @summary Creates Sampledata for UI tests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSampleData: (options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/sampledata/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns the last mail that was sent by the system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastMail: (options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/sampledata/emails/last`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.SampleDataApiAxiosParamCreator = SampleDataApiAxiosParamCreator;
/**
 * SampleDataApi - functional programming interface
 * @export
 */
const SampleDataApiFp = function (axiosClientConfiguration) {
    return {
        /**
         *
         * @summary Creates Sampledata for UI tests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSampleData(options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.SampleDataApiAxiosParamCreator)(axiosClientConfiguration).createSampleData(options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @summary Returns the last mail that was sent by the system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastMail(options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.SampleDataApiAxiosParamCreator)(axiosClientConfiguration).getLastMail(options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
    };
};
exports.SampleDataApiFp = SampleDataApiFp;
/**
 * SampleDataApi - factory interface
 * @export
 */
const SampleDataApiFactory = function (axiosClientConfiguration, basePath, axios) {
    return {
        /**
         *
         * @summary Creates Sampledata for UI tests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSampleData(options) {
            return (0, exports.SampleDataApiFp)(axiosClientConfiguration).createSampleData(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns the last mail that was sent by the system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastMail(options) {
            return (0, exports.SampleDataApiFp)(axiosClientConfiguration).getLastMail(options).then((request) => request(axios, basePath));
        },
    };
};
exports.SampleDataApiFactory = SampleDataApiFactory;
/**
 * SampleDataApi - object-oriented interface
 * @export
 * @class SampleDataApi
 * @extends {BaseAPI}
 */
class SampleDataApi extends base_1.BaseAPI {
    /**
     *
     * @summary Creates Sampledata for UI tests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SampleDataApi
     */
    createSampleData(options) {
        return (0, exports.SampleDataApiFp)(this.axiosClientConfiguration).createSampleData(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns the last mail that was sent by the system
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SampleDataApi
     */
    getLastMail(options) {
        return (0, exports.SampleDataApiFp)(this.axiosClientConfiguration).getLastMail(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SampleDataApi = SampleDataApi;
